<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :config-module="configModule"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          @gridReady="onGridReady"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import { getFileStateByCode } from '@/class/cargo/model/parameters/FileState'
import * as XhqCustomState from '@/class/cargo/model/parameters/XhqCustomState'
import { cache, cacheName } from '@/utils/cacheManager'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'CustomsFileGrid',
  components: {},
  props: {
    configModule: { type: String, default: '224100' },
    showCostOrSell: { type: Boolean, default: false },
    showCost: { type: Boolean, default: false },
    showApprove: { type: Boolean, default: false },
    showModify: { type: Boolean, default: false },
    showBranch: { type: Boolean, default: false },
    showCreate: { type: Boolean, default: false },
    showHistory: { type: Boolean, default: false },
    showBasicInfo: { type: Boolean, default: true },
    gridOptions: { type: Object, default: () => {} },
    rowData: { type: Array, default: () => [] }
  },
  data() {
    return {
      showLevel: false, // 是否显示运价等级
      txtRemarks: '',
      remarkChange: false,
      authedLevel: 99,
      proxy: {},
      filterJson: {},
      showDetail: false,
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: ' ', maxWidth: 40, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('SeaExport.BusinessNo'), field: 'jobNo', width: 200,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'router-and-print',
            attrs: {
              useRoute: true,
              usePrint: true,
              routeName: 'SeaBooking',
              routeParamKeys: { jobNo: 'jobNo' },
              routeTitle: this.$t('route.bookingNew'),
              routePermissions: ['module_fmBookingNew'],
              extraRouteParams: {},
              printMethod: this.showBusinessInfo
            }
          }
        },
        {
          headerName: this.$t('SeaExport.Customer'), field: 'customerId', colId: 'customerId', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.OperatingCompany'), field: 'companyCName', colId: 'companyCName', width: 200 },

        {
          headerName: this.$t('SeaExport.CustomsNo'), field: 'customsNo',
          colId: 'customsNo', suppressMenu: true,
          minWidth: 200,
          // 是否开启编辑
          editable: true,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: false
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        { headerName: this.$t('SeaExport.FileNo'), field: 'fileNo', colId: 'fileNo', width: 200 },
        { headerName: this.$t('SeaExport.Status'), field: 'state', colId: 'state', width: 200,
          valueFormatter: (params) => {
            if (!params.data.createdBy) { return this.$t('SeaExport.NoDeclarationFormCreated') }
            const c = getFileStateByCode(params.value)
            if (c) {
              return c.chineseName
            }
            return ''
          }
        },
        { headerName: this.$t('SeaExport.DepartureTime'), field: 'etd', colId: 'etd', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.SendingDate'), field: 'sendDate', colId: 'sendDate', width: 200,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.DateOfOrder'), field: 'acceptedDate', colId: 'acceptedDate', width: 200,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.ProjectReceivedBy'), field: 'acceptedUser', colId: 'acceptedUser', width: 200,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.ReceivingDate'), field: 'backDate', colId: 'backDate', width: 200,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.Receiver'), field: 'backUser', colId: 'backUser', width: 200,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.dateOfFiling'), field: 'filedDate', colId: 'filedDate', width: 200,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.ArchivePeople'), field: 'filedUser', colId: 'filedUser', width: 200,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.RefundDate'), field: 'rebatedDate', colId: 'rebatedDate', width: 200,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.RefundPerson'), field: 'rebatedUser', colId: 'rebatedUser', width: 200,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.ReturnDate'), field: 'returnDate', colId: 'returnDate', width: 200,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CustomsBroker'), field: 'customsBroker', colId: 'customsBroker', width: 200,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.Mbl2'), field: 'mbl', colId: 'mbl', width: 200 },
        { headerName: this.$t('SeaExport.ReturnOrderExpressNumber'), field: 'returnExpressNo', colId: 'returnExpressNo', width: 200, hide: true },
        {
          headerName: this.$t('SeaExport.TakeByCustomsBroker'), field: 'isTax', colId: 'isTax', width: 200,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        },
        { headerName: this.$t('SeaExport.DateOfCreation'), field: 'dateCreated', colId: 'dateCreated', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.Creator'), field: 'createdBy', colId: 'createdBy', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.Operation'), field: 'op', colId: 'op', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.Sales'), field: 'sales', colId: 'sales', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'), field: 'cargoChineseName', colId: 'cargoChineseName', width: 200 },
        {
          headerName: this.$t('SeaExport.CommodityInspectionOrNot'), field: 'commodityInspection', colId: 'commodityInspection', width: 200,
          valueFormatter: (params) => {
            return params.value ? '√' : ''
          }
        },
        {
          headerName: this.$t('SeaExport.CustomsInspectionOrNot'), field: 'spotInspection', colId: 'spotInspection', width: 200,
          valueFormatter: (params) => {
            return params.value ? '√' : ''
          }
        },
        { headerName: this.$t('SeaExport.Remarks'), field: 'remark', colId: 'remark', width: 200 },
        {
          headerName: this.$t('SeaExport.DateOfCustomsDeclaration'),
          field: 'customsDate',
          colId: 'customsDate',
          width: 120,
          hide: true,
          valueFormatter: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CustomsDeclarationRemark'),
          field: 'remarks',
          colId: 'remarks',
          width: 200,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.TenBitCode'),
          field: 'tenDigitCode',
          colId: 'tenDigitCode',
          width: 120,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
          field: 'cargoEnglishName',
          colId: 'cargoEnglishName',
          width: 200,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.TradeMethod'),
          field: 'tradeTerm',
          colId: 'tradeTerm',
          width: 120,
          hide: true,
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_TradeTerm, 'code', params.value, 'name')
          }
        },
        {
          headerName: this.$t('CargoMsg.XhqCustomerState'),
          field: 'xhqCustomState',
          colId: 'xhqCustomState',
          width: 200,
          hide: true,
          suppressColumnsToolPanel: !(Number(cache.config.get('xinHaoQiApi')) === 2),
          valueFormatter: (params) => {
            if (params.value === XhqCustomState.SENT_LCL_TASK.code) {
              return this.$t('CargoMsg.LCLTaskSent')
            } else if (params.value === XhqCustomState.SENT.code) {
              return this.$t('CargoMsg.CustomerFileHasBeenSent')
            } else {
              return this.$t('CargoMsg.NotSendingCustomerFile')
            }
          }
        },
        { headerName: this.$t('CargoMsg.CustomsUnFrozen'), field: 'customsUnfrozenState', colId: 'customsUnfrozenState', width: 200,
          hide: true,
          suppressColumnsToolPanel: !(Number(cache.config.get('xinHaoQiApi')) === 2),
          valueFormatter: (params) => {
            return !params.value ? this.$t('CargoMsg.NotUnfreeze') : this.$t('CargoMsg.Unfreeze')
          }
        },
        {
          headerName: this.$t('SeaExport.NCReferenceNo'),
          field: 'agentRefNo',
          colId: 'agentRefNo',
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.CBANumber'),
          field: 'cbaNumber',
          colId: 'cbaNumber',
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.CustomsStatus'),
          field: 'customsStatus',
          colId: 'customsStatus',
          hide: true,
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.columnLabelFunc(SystemConstants.CUSTOMS_STATUS, params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CustomsBrokerStatus'),
          field: 'customsBrokerStatus',
          colId: 'customsBrokerStatus',
          hide: true,
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.columnLabelFunc(SystemConstants.CUSTOMS_BROKER_STATUS, params.value)
          }
        },
        { headerName: this.$t('CargoMsg.CustomsDeclareTime'), field: 'declareTime', width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CustomerService'),
          field: 'csr',
          colId: 'csr',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          hide: true,
          width: 150
        }
      ]
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    },
    hideCost() {
      return !(!this.showCostOrSell && this.showCost)
    }
  },
  methods: {
    onGridReady(p) {
      this.gridApi = p.api
    },
    numberColumnLabelFunc(params) {
      if (params.value === 0.0) {
        return 0
      }
      return PriceUtils.priceByViewColumnLabelFunc_nolimit(params, null)
    },
    async onCellChange(params) {
      const newParams = {
        uuid: params.data.uuid,
        customsNo: params.newValue,
        originalValue: params.oldValue
      }
      if (newParams.uuid) {
        this.$emit('batchSaveHandler', newParams)
      }
    }
  }
}
</script>
<style lang="scss">
</style>

